import { ref, onMounted } from 'vue'

const defaultConfig = {
  immde: false,
  params: {},
  after: null
};
export const useRequest = (request, config) => {
  const { immde, params, after } = { ...defaultConfig, ...config, };
  const data = ref();
  const error = ref();
  const loading = ref(false);

  function reset() {
    data.value = {};
    error.value = null;
    loading.value = false;
  }

  async function run(p) {
    const _params = p || params;
    try {
      loading.value = true;
      error.value = null;
      const res = await request(_params);
      data.value = after ? after(res) : res;
    } catch (e) {
      error.value = e;
      data.value = null;
    } finally {
      loading.value = false;
    }
  }

  onMounted(() => {
    if (immde) run();
  })

  return { data, error, loading, run }
}

